import Vue from 'vue'
import VueRouter from 'vue-router'

import BuildingsView from '@/views/Buildings'
import UserView from '@/views/User'
import Declarations from '@/views/Declarations'
import Welcome from '@/views/Welcome'
import Receipts from '@/views/Receipts'
import VerificationShort from '@/views/VerificationShort'


const routes = [
  { path: '', name: 'welcome', component: Welcome },
  { path: '/buildings', name: 'buildings', component: BuildingsView },
  { path: '/declarations', name: 'declarations', component: Declarations },
  { path: '/user', name: 'user', component: UserView },
  { path: '/receipts', name: 'receipts', component: Receipts },
  { path: '/verify', name: 'verify', component: VerificationShort },
]

Vue.use(VueRouter)
const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) { return { x: 0, y: 0 } },
  mode: 'hash',
  routes
})

export default router
